module.exports = __webpack_public_path__ + "img/takarajima.6e396bd0.png";